import { useEffect, useState } from 'react'

/**
 * A ticking clock.
 *
 * Ticks are re-aligned to the wall clock after every fire, so the display does
 * not drift when a phone suspends the tab and resumes it minutes later.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    let timeout: number

    const schedule = () => {
      const delay = intervalMs - (Date.now() % intervalMs)
      timeout = window.setTimeout(() => {
        setNow(Date.now())
        schedule()
      }, delay)
    }

    schedule()

    // A backgrounded tab throttles timers; resync the moment it returns.
    const onVisible = () => {
      if (document.visibilityState === 'visible') setNow(Date.now())
    }
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      window.clearTimeout(timeout)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [intervalMs])

  return now
}
